// queryKeys centralizadas. Permite invalidaciones quirúrgicas y autocompletado.
// Convención: tuplas readonly tipadas. Cada feature agrega su namespace acá.

export const qk = {
  auth: {
    me: ['auth', 'me'] as const,
  },
  usuarios: {
    all: ['usuarios'] as const,
    list: (params: { skip?: number; take?: number; rol?: string; activo?: boolean }) =>
      ['usuarios', 'list', params] as const,
    lookup: (params: { activo?: boolean; limit?: number; rol?: string | string[] }) =>
      ['usuarios', 'lookup', params] as const,
    detail: (id: string) => ['usuarios', 'detail', id] as const,
  },
  // ciclo-emisor: las campañas de envío.
  campanasEnvio: {
    all: ['campanas-envio'] as const,
    detail: (id: string) => ['campanas-envio', 'detail', id] as const,
    envios: (id: string, estado?: string) => ['campanas-envio', 'envios', id, estado ?? 'todos'] as const,
    opciones: ['campanas-envio', 'opciones'] as const,
    audiencia: (filtros: unknown) => ['campanas-envio', 'audiencia', filtros] as const,
  },
  campanas: {
    all: ['campanas'] as const,
  },
  notificaciones: {
    list: (filters: Record<string, unknown> = {}) => ['notificaciones', 'list', filters] as const,
    contador: ['notificaciones', 'contador'] as const,
  },
  leads: {
    all: ['leads'] as const,
    list: (params: { filtro: string; buscar?: string; campana?: string; etapa?: number }) =>
      ['leads', 'list', params] as const,
    detail: (id: string) => ['leads', 'detail', id] as const,
    mensajes: (id: string) => ['leads', 'mensajes', id] as const,
  },
  instancias: {
    all: ['instancias'] as const,
  },
  publicaciones: {
    all: ['publicaciones'] as const,
    lista: ['publicaciones', 'lista'] as const,
    mes: (desde: string, hasta: string) => ['publicaciones', 'mes', desde, hasta] as const,
  },
  tareas: {
    all: ['tareas'] as const,
    estadisticas: ['tareas', 'estadisticas'] as const,
    semanaActual: ['tareas', 'semana-actual'] as const,
  },
  admin: {
    errores: (filters: Record<string, unknown> = {}) => ['admin', 'errores', filters] as const,
    configuracion: ['admin', 'configuracion'] as const,
    apiKeys: ['admin', 'api-keys'] as const,
    sistema: ['admin', 'sistema'] as const,
    recontacto: ['admin', 'recontacto'] as const,
    metricas: (params: { desde?: string; hasta?: string; campana?: string }) =>
      ['admin', 'metricas', params] as const,
  },
  metricas: {
    // ciclo-metricas-embudo-y-contenido: prefijo ['metricas','embudo'] para poder
    // invalidar TODAS las variantes (cualquier rango de fecha) de una — el evento
    // SSE de un lead no sabe qué rango tiene abierto la usuaria.
    embudo: (params: { desde?: string; hasta?: string; campana?: string }) =>
      ['metricas', 'embudo', params] as const,
    contenido: (params: { desde?: string; hasta?: string }) => ['metricas', 'contenido', params] as const,
    // ciclo-calidad-leads: mismo prefijo, así el SSE de un lead calificado lo refresca.
    calidad: (params: { desde?: string; hasta?: string; campana?: string }) =>
      ['metricas', 'calidad', params] as const,
  },
  conexiones: {
    all: ['conexiones'] as const,
  },
} as const;
